import api from './api';

// Talks to /api/journals/* — finance's top-side adjustments.
//
// There is no posting call: a saved line IS the adjustment and is on the P&L
// immediately. This is a budget, not a ledger.
//
// Version comes from the x-budget-version-id header; NOT site-scoped, because
// most top-side adjustments belong to no single depot. A line may still name a
// site, and then it shows on that site's own P&L.
export const journalService = {
  // { journals: [...with imbalances + is_balanced], picks: { accounts, costCenters, sites } }
  //
  // Accounts are already filtered to those the chart of accounts allows
  // journals against (allow_manual_journals) — control accounts are not on the
  // list at all rather than offered and then refused on save.
  list: async () => {
    const res = await api.get('/journals');
    return res.data;
  },

  // { journal, lines (12 periods each, gaps filled), imbalances }
  get: async (journalId) => {
    const res = await api.get(`/journals/${encodeURIComponent(journalId)}`);
    return res.data;
  },

  create: async (description) => {
    const res = await api.post('/journals', { description });
    return res.data;
  },

  updateHeader: async (journalId, patch) => {
    const res = await api.put(`/journals/${encodeURIComponent(journalId)}`, patch);
    return res.data;
  },

  // The whole line set in one call: lines with an id are updated, lines without
  // are inserted, anything absent is deleted. Matches what the grid shows.
  saveLines: async (journalId, lines) => {
    const res = await api.put(`/journals/${encodeURIComponent(journalId)}/lines`, { lines });
    return res.data;
  },

  remove: async (journalId) => {
    const res = await api.delete(`/journals/${encodeURIComponent(journalId)}`);
    return res.data;
  },
};

export default journalService;
